export default __webpack_public_path__ + "static/media/dialog_error.43f24e4e.svg";